module.exports = ".information-box label {\n    padding-bottom: 0 !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/owners/css/detail.component.css
// module id = ./src/app/modules/owners/css/detail.component.css
// module chunks = main